import classNames from "classnames";
import { Typography } from "ui-kit/Typography";
import styles from "./MiniSwitch.module.css";
import { useState } from "react";

function Option<Value>({
  value,
  option,
  onChange,
  name,
}: {
  value: Value;
  option: { label: string; value: Value };
  onChange: (value: Value) => void;
  name: string;
}) {
  return (
    <label className={classNames(styles.option)}>
      <input
        type="radio"
        checked={value === option.value}
        style={{ appearance: "none" }}
        name={name}
        onChange={() => onChange(option.value)}
      />
      <Typography
        variant="body3"
        color={value === option.value ? "blue300" : "grey500"}
      >
        {value === option.value ? (
          <strong>{option.label}</strong>
        ) : (
          option.label
        )}
      </Typography>
    </label>
  );
}

export function MiniSwitch<Value = unknown>({
  options,
  value,
  onChange,
  className,
  ariaLabel,
  name,
}: {
  options: [{ label: string; value: Value }, { label: string; value: Value }];
  value: Value;
  onChange: (value: Value) => void;
  className?: string;
  ariaLabel: string;
  name: string;
}) {
  const [internalValue, setInternalValue] = useState(
    value === options[0].value ? options[0].value : options[1].value
  );

  return (
    <div
      className={classNames(styles.container, className)}
      aria-label={ariaLabel}
      role="group"
    >
      <Option
        name={name}
        value={internalValue}
        option={options[0]}
        onChange={(value) => {
          setInternalValue(value);
          onChange(value);
        }}
      />
      <div
        className={classNames(
          styles.switch,
          internalValue === options[1].value && styles.switchRight
        )}
        onClick={() => {
          const newValue =
            internalValue === options[0].value
              ? options[1].value
              : options[0].value;
          setInternalValue(newValue);

          onChange(newValue);
        }}
      >
        <div className={styles.indicator} />
      </div>
      <Option
        value={internalValue}
        option={options[1]}
        onChange={(value) => {
          setInternalValue(value);
          onChange(value);
        }}
        name={name}
      />
    </div>
  );
}
